import styled from 'styled-components';

export const CheckCardListContainer = styled.div`
  display: flex;
  flex-direction: column;

  .link {
    width: 100%;
  }

  .link:hover span {
    text-decoration: none;
  }
`;
